import { Component, OnInit } from '@angular/core';
import { TotemService } from '../totem.service';
import { getLocaleDayPeriods } from '@angular/common';
import * as moment from 'moment';
@Component({
  selector: 'app-cine',
  templateUrl: './cine.component.html',
  styleUrls: ['./cine.component.css']
})
export class CineComponent implements OnInit {
  listapeliculas = [];
  constructor(  private totemService: TotemService) { }

  async ngOnInit() {
    const peliculas = await this.totemService.geteventos().subscribe(eventos => {
      for (const peli of eventos) {
        if (peli.tipo_evento === 'Cartelera' && peli.publicado === 1) {
          if (moment().isBetween(peli.dia_inicio, peli.dia_termino)) {
            this.listapeliculas.push(peli);
          }

        }
      }
      console.log('peliculas', eventos);
    });
  }
   // logica de reinicio
   scrollevent = (event: any): void => {
     console.log('scroll');
     this.cancelartimer();
  }
  public cancelartimer() {
    this.totemService.emitirReinicioTotem();
  }

}
